import {Alert, Button, Space} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import type {ReviewOfferingType} from "../../../react-query-hooks/reviews/types";
import {StyledSessionDetailsDrawer} from "../../calls/service/sales-and-insights/customers-section/style";
import {
  ReviewForm,
  ReviewFormProps,
} from "../../calls/past-calls/past-call-card/customer";
import {useGetCustomerReview} from "../../../react-query-hooks/reviews/get-reviews";
import {FullPageLoader} from "../../full-page-loader";

const SUBSCRIPTION_OFFERING_TYPE: ReviewOfferingType = "subscription";

export type CustomerSubscriptionReviewFormDrawerProps = {
  title: string;
  isVisible: boolean;
  onClose: () => void;
  /** Ratings API `offeringId` — store subscription id */
  offeringId: ReviewFormProps["offeringId"];
  customerFirstName: string;
  customerLastName: string;
  customerEmail: string;
};

export function CustomerSubscriptionReviewFormDrawer({
  title,
  isVisible,
  onClose,
  offeringId,
  customerFirstName,
  customerLastName,
  customerEmail,
}: CustomerSubscriptionReviewFormDrawerProps) {
  const getCustomerReview = useGetCustomerReview({
    emailAddress: customerEmail.trim(),
    offering_id: offeringId,
    offering_type: SUBSCRIPTION_OFFERING_TYPE,
  });

  const hasEmail = customerEmail.trim().length > 0;

  return (
    <StyledSessionDetailsDrawer
      title={title}
      placement="right"
      onClose={onClose}
      visible={isVisible}
      closable={false}
      destroyOnClose
      extra={
        <Button type="text" size="small" icon={<CloseOutlined />} onClick={onClose} />
      }
      footer={null}
    >
      {!hasEmail ? (
        <Alert
          type="warning"
          showIcon
          message="We could not detect your email. Sign in again, then leave a review."
        />
      ) : getCustomerReview.isLoading ? (
        <FullPageLoader />
      ) : (
        <Space direction="vertical" style={{display: "flex"}} size={24}>
          <ReviewForm
            reviewData={getCustomerReview.data}
            offeringId={offeringId}
            offeringType={SUBSCRIPTION_OFFERING_TYPE}
            closeReviewFormDrawer={onClose}
            customerFirstName={customerFirstName}
            customerLastName={customerLastName}
            customerEmail={customerEmail.trim()}
            relaxedRatingStarSpacing
          />
        </Space>
      )}
    </StyledSessionDetailsDrawer>
  );
}
